import React, {useState, useEffect} from 'react'
import useToast from '@/hooks/useToast'
import * as constants from '@constants'
import ErrorToast from '@components/ErrorToast'
import {purchaseOrderProductsGet as purchaseOrderStylesGet, salesOrderProductsGet as salesOrderStylesGet} from '@services/api/cascade-tracing-service'
import * as api from '@api'
import useFeature from '@/hooks/useFeature'

export default function useProducts(orderType) {
  const {toast} = useToast()
  const {isNewStyleStructureEnabled} = useFeature()
  const [products, setProducts] = useState([])

  useEffect(() => {
    const fetchProducts = isNewStyleStructureEnabled
      ? (orderType === constants.TRACE_TYPE_ENUM.PURCHASE_ORDER ? purchaseOrderStylesGet : salesOrderStylesGet)
      : (orderType === constants.TRACE_TYPE_ENUM.PURCHASE_ORDER ? api.purchaseOrderProductsGet : api.salesOrderProductsGet)

    fetchProducts().then(response => {
      if (response.status >= 400) {
        toast.custom(t => <ErrorToast t={t} error={response.error} />)
      } else {
        setProducts(response.data?.data || [])
      }
    })
  }, [])

  return products
}
